<template>
  <div id="indicator" v-if="amountOfActiveFilters() > 0">{{ amountOfActiveFilters() }}</div>
</template>

<style scoped>
#indicator {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  background-color: teal;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 20px;
  bottom: 15px;
  font-size: 13px;
}
</style>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Filter } from '@/domain/interface/Filter';
import {determineIfActiveArray, determineIfActiveBoolean, determineIfActiveObject} from '@/util/filters/filterUtil';

@Component({})
export default class ActiveFilterIndicator extends Vue {
  @Prop() filter: Filter;

  amountOfActiveFilters(): number {
    return Object.keys(this.filter)
      .map((key) => this.determineIfActive(key))
      .reduce((a, b) => a + b);
  }

  private determineIfActive(key: string): number {
    if (key === 'searchString') {
      return 0;
    }

    if (Array.isArray(this.filter[key])) {
      return determineIfActiveArray(this.filter[key]) ? 1 : 0;
    }

    if (key === 'publiekGebouw' || key === 'overheidsgebouw') {
      return determineIfActiveBoolean(this.filter[key]) ? 1 : 0;
    }

    if (typeof this.filter[key] === 'object') {
      return determineIfActiveObject(this.filter[key]) ? 1 : 0;
    }
    return 0;
  }
}
</script>
